/* tslint:disable */
/* eslint-disable */
/**
 * Risks API
 * API for managing risks.
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ReadRiskMinimalDto } from './ReadRiskMinimalDto';
import {
    ReadRiskMinimalDtoFromJSON,
    ReadRiskMinimalDtoFromJSONTyped,
    ReadRiskMinimalDtoToJSON,
    ReadRiskMinimalDtoToJSONTyped,
} from './ReadRiskMinimalDto';

/**
 * 
 * @export
 * @interface GetRiskSimulationsResponseDto
 */
export interface GetRiskSimulationsResponseDto {
    /**
     * 
     * @type {Array<ReadRiskMinimalDto>}
     * @memberof GetRiskSimulationsResponseDto
     */
    risks: Array<ReadRiskMinimalDto>;
}

/**
 * Check if a given object implements the GetRiskSimulationsResponseDto interface.
 */
export function instanceOfGetRiskSimulationsResponseDto(value: object): value is GetRiskSimulationsResponseDto {
    if (!('risks' in value) || value['risks'] === undefined) return false;
    return true;
}

export function GetRiskSimulationsResponseDtoFromJSON(json: any): GetRiskSimulationsResponseDto {
    return GetRiskSimulationsResponseDtoFromJSONTyped(json, false);
}

export function GetRiskSimulationsResponseDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetRiskSimulationsResponseDto {
    if (json == null) {
        return json;
    }
    return {
        
        'risks': ((json['risks'] as Array<any>).map(ReadRiskMinimalDtoFromJSON)),
    };
}

export function GetRiskSimulationsResponseDtoToJSON(json: any): GetRiskSimulationsResponseDto {
    return GetRiskSimulationsResponseDtoToJSONTyped(json, false);
}

export function GetRiskSimulationsResponseDtoToJSONTyped(value?: GetRiskSimulationsResponseDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'risks': ((value['risks'] as Array<any>).map(ReadRiskMinimalDtoToJSON)),
    };
}

